<div class="container mt-3">
    <h2><i class="fa fa-envelope-o me-3" aria-hidden="true"></i>Skickade mejl</h2>
    

    <table class="table border table-striped w-75 table-lg">
        <thead>
            <tr>
                <th>Datum</th>
                <th>Ämne</th>
                <th>Antal mail</th>
                <th>Antal felaktiga</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let campaign of campaigns">
                <td>{{ campaign.date | date: 'yyyy-MM-dd HH:mm' }}</td>
                <td class="fw-bold">{{ campaign.subject }}</td>
                <td>{{ campaign.numberOfRecipients }}</td>
                <td>
                        <a
                            *ngIf="campaign.numberOfFailedMails > 0"
                            [routerLink]="['/failed-mails', campaign.id]">
                            {{ campaign.numberOfFailedMails }}
                        </a>

                        <span *ngIf="campaign.numberOfFailedMails === 0">
                            {{ campaign.numberOfFailedMails }}
                        </span>
                </td>
            </tr>
        </tbody>
    </table>
</div>
